export default __webpack_public_path__ + "d4984dd3006b0bd430b2a5d9a4a8462e.otf";